import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'absolute',
    standalone: false
})
export class AbsolutePipe implements PipeTransform {

    transform(value: number): any {
        if (isNaN(+value)) {
            return value;
        }

        return Math.abs(value);
    }

}
